<template>
	<div>
		<SentimentUpLimit></SentimentUpLimit>
		<SentimentZhaban></SentimentZhaban>
		<v-chart :options="polar" />
		<!-- <v-chart class="my-chart" :options="bar" /> -->
		<!-- <div>{{polar}}</div> -->
	</div>
</template>

<script>
	import SentimentUpLimit from 'components/sentiment/SentimentUpLimit.vue'
	import SentimentZhaban from 'components/sentiment/SentimentZhaban.vue'
	import ECharts from 'vue-echarts'
	import 'echarts/lib/chart/line'
	import "echarts/lib/chart/bar";
	import "echarts/lib/chart/candlestick";
	import 'echarts/lib/component/title'
	import "echarts/lib/component/dataZoom";
	import "echarts/lib/component/axis";
	import "echarts/lib/component/axisPointer";
	import "echarts/lib/component/tooltip";
	import "echarts/lib/component/toolbox";
	import "echarts/lib/component/legend";
	import "echarts/lib/component/markLine";
	import "echarts/lib/component/markPoint";
	import "echarts/lib/component/markArea";
	import "echarts/lib/component/timeline";
	import "echarts/lib/component/visualMap";

	export default {
		components: {
			'v-chart': ECharts,
			SentimentZhaban,
			SentimentUpLimit,
		},
		data() {
			let data = []

			for (let i = 0; i <= 360; i++) {
				let t = i / 180 * Math.PI
				let r = Math.sin(2 * t) * Math.cos(2 * t)
				data.push([r, i])
			}

			return {
				polar: {
					title: {
						text: '极坐标双数值轴'
					},
					legend: {
						data: ['line']
					},
					polar: {
						center: ['50%', '54%']
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					angleAxis: {
						type: 'value',
						startAngle: 0
					},
					radiusAxis: {
						min: 0
					},
					series: [{
						coordinateSystem: 'polar',
						name: 'line',
						type: 'line',
						showSymbol: false,
						data: data
					}],
					animationDuration: 2000
				},
				bar: {
					title: {
						text: "ECharts 入门示例"
					},
					tooltip: {},
					legend: {
						data: ["销量"]
					},
					xAxis: {
						data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
					},
					yAxis: {},
					series: [{
						name: "销量",
						type: "bar",
						data: [5, 20, 36, 10, 10, 20]
					}]
				}
			}
		}
	}
</script>

<style scoped>

</style>
